// extracted by mini-css-extract-plugin
export default {"mainContainer":"Articles_mainContainer__MHUzi","container":"Articles_container__2LQiM"};